import { Dialog, ButtonCallbacks } from '@/components/types/Dialog';

export const insecurePasswordDialog: Dialog = {
  title: 'common.insecurePasswordTitle',
  maxWidth: '590px',
  buttonConfig: [
    {
      callbackID: ButtonCallbacks.CANCEL,
      text: 'app.logout',
      outlined: true
    },
    {
      callbackID: ButtonCallbacks.ACTION,
      text: 'settings.changePassword'
    }
  ]
};

export const ssoPreferredDialog: Dialog = {
  title: 'app.ssoPreferredTitle',
  maxWidth: '590px',
  buttonConfig: [
    {
      callbackID: ButtonCallbacks.OK,
      text: 'common.ok'
    }
  ]
};
